import * as React from "react";

import {cs}               from "@Common/react/chain-services";
import {InformedDelivery} from "@Common/ui-components/heavy/item-options/modules/informed-delivery/informed-delivery";
import {
    alterPrepareSaveValue, nestData
}                         from "@Common/ui-components/heavy/item-options/modules/informed-delivery/nest-editor-path";

import {enrollmentEditor, ui} from "../common/expo-types";

export const InformedDeliveryModules = ({initEnrollment, templateOptions}) => [
    {
        load: ({method}, next) => cs(
            ["informedDelivery", ({}, next) => InformedDelivery({
                // itemId: item?.itemId,
                // agentId: item?.idAgent,
                initData: initEnrollment?.profile?.informedDelivery,
                disabled: method !== "mailing",
                templateOptions,

                representativeImage: {
                    // maybeLoading: true,
                },
                next,
            })],
            ({informedDelivery}) => next({
                enrollmentEditor: {
                    ...informedDelivery.editor,
                    prepareSave: alterPrepareSaveValue(informedDelivery.editor.prepareSave, [
                        nestData(["profile", "informedDelivery"]),
                    ]),
                },
                ui: ({showErrors}) => !informedDelivery.permanentlyDisabled && (
                    <div className="informed-delivery">
                        {informedDelivery.renderHeader({})}

                        {informedDelivery.render?.({showErrors})}
                    </div>
                )
            }),
        ),
        expo: [enrollmentEditor, ui(6, {hasSpacer: true})],
        requires: ["method"],
    },
];


